/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelFactoringCompany.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/factoring-company";

export class AutogenModelFactoringCompany<RowType extends ModelRow> extends Endpoint<RowType, RowFactoringCompanyFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowFactoringCompany extends ModelRow<RowFactoringCompanyFields> {
	constructor(values?: Partial<RowFactoringCompanyFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowFactoringCompanyFields {
	ach_batch_class_code: string;
	address: string;
	city: string;
	company_id: string;
	email: string;
	external_xref: string;
	id: string;
	is_active: string;
	name: string;
	payment_method: string;
	phone_number: string;
	state: string;
	zip_code: string;
}

